import { ReactNode } from 'react'
import Image from 'next/image'
import { Button, IconPlayDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'

interface HeroLayoutProps {
  children: ReactNode
  imageUrl?: string
  imageAlt: string
  showTrailerButton?: boolean
  onTrailerClick?: () => void
  trailerMediaUuid?: string
  className?: string
  media?: ReactNode
}

export const HeroLayout = ({
  children,
  imageUrl,
  imageAlt,
  showTrailerButton = false,
  onTrailerClick,
  trailerMediaUuid,
  className,
  media,
}: HeroLayoutProps) => {
  const { t } = useTranslation('@mc/certificates')

  return (
    <div className={className}>
      <div className='container flex flex-col items-center justify-between gap-9 my-7 md:my-8 lg:flex-row'>
        <div className='flex flex-[5] flex-col items-center gap-6 lg:items-start'>
          {children}
        </div>

        {imageUrl && (
          <div className='relative aspect-square w-full max-w-[615px] flex-[4]'>
            <Image
              className='rounded-xl object-cover'
              src={imageUrl}
              alt={imageAlt}
              fill
              sizes='(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 615px'
              priority
            />
            {media}
            {showTrailerButton && trailerMediaUuid && (
              <Button
                kind='secondary'
                className='absolute bottom-0 left-0 m-5 rounded-lg px-4 py-2'
                onClick={onTrailerClick}
              >
                <div className='mr-2 flex items-center justify-center rounded-full bg-c-base-1400 p-1 text-c-text-light'>
                  <IconPlayDefault size='sm' />
                </div>
                {t('marketingPages.common.playTrailer')}
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
